import styled from 'styled-components';

const SearchResultImage = styled.img<{ variant: 'compact' | 'standard' }>`
  flex: 0 0 auto;
  max-height:
    ${({ variant }) => {
    switch (variant) {
      case 'compact':
        return '32px';
      case 'standard':
      default:
        return '64px';
    }
  }};
  max-width:
    ${({ variant }) => {
    switch (variant) {
      case 'compact':
        return '32px';
      case 'standard':
      default:
        return '64px';
    }
  }};
`;

export default SearchResultImage;
